import * as yup from 'yup';


/**
 * @param {?Account} account
 * @return {Object}
 */
export const getSyncPreferenceDefault = (account) => {
  const accountCals = account?.calendars || [];
  const pushCalendar = accountCals.find((cal) => cal.id === account?.pushCalendarId && cal.writeAccess);
  const isPushCalendarValid = !!pushCalendar;

  const writeCalendars = accountCals.filter((cal) => cal.writeAccess);
  const firstWriteCalId = writeCalendars[0]?.id || '';
  const isEditing = account?.pushEnabled;

  return {
    selectedAccountEmail: account?.email || '',
    selectedAccountService: account?.service,
    // if pushCalendarId not valid, have the first possible writeCalendar initially selected.
    pushCalendarId: isPushCalendarValid ? account?.pushCalendarId || firstWriteCalId : firstWriteCalId,
    // if editing, initially have webhooksEnabled set to true
    webhooksEnabled: isEditing ? account?.webhooksEnabled ?? false : true,
  };
};

export const getSyncPreferenceSchema = (t) => {
  return yup.object({
    selectedAccountEmail: yup.string(),
    pushCalendarId: yup.string().required(),
    webhooksEnabled: yup.boolean(),
  });
};
